import React from "react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

export const emptyIssuer = () => ({ name: "NYAYYAKSHA", address: "", email: "", phone: "", taxId: "", paymentInstructions: "" });

export function IssuerFields({ value, onChange, disabled = false, prefix = "doc-issuer" }) {
  const field = (key, text, multiline = false) => {
    const Control = multiline ? Textarea : Input;
    return <label key={key} className="block text-xs text-ink-2" htmlFor={`${prefix}-${key}`}>{text}<Control id={`${prefix}-${key}`} data-testid={`${prefix}-${key}`} className="mt-1 bg-card" value={value[key] || ""} maxLength={multiline ? 1500 : 150} rows={multiline ? 2 : undefined} disabled={disabled} onChange={(e) => onChange({ ...value, [key]: e.target.value })} /></label>;
  };
  return <div className="space-y-3" data-testid={`${prefix}-fields`}>
    <p className="text-xs text-ink-muted" data-testid={`${prefix}-default-note`}>NYAYYAKSHA is the default issuer. Firm, contact, tax and payment details appear only when you enter and save them here.</p>
    {field("name", "Issuer name")}{field("address", "Issuer address (optional)", true)}
    <div className="grid grid-cols-2 gap-3">{field("email", "Email (optional)")}{field("phone", "Phone (optional)")}</div>
    {field("taxId", "Tax / registration ID (optional)")}{field("paymentInstructions", "Payment instructions (optional)", true)}
  </div>;
}

export async function downloadBlob(response, fallback) {
  const disposition = response.headers["content-disposition"] || "";
  const name = disposition.match(/filename="([^"]+)"/)?.[1] || fallback;
  const url = URL.createObjectURL(response.data);
  const anchor = document.createElement("a");
  anchor.href = url; anchor.download = name; document.body.appendChild(anchor); anchor.click(); anchor.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export async function exportError(error) {
  if (error.response?.data instanceof Blob) {
    try { return JSON.parse(await error.response.data.text()).detail || "Export failed"; } catch { return "Export failed. Your saved content is unchanged."; }
  }
  return typeof error.response?.data?.detail === "string" ? error.response.data.detail : "Could not save or export this document";
}
